export const managerHeatmapFetchDataKeyReset = (state, payload) => {
  return {
    ...state,
    isDataFetchedManager: false
  }

}